<template>
  <form novalidate @submit.prevent="handleSubmit">
    <SectionTitle
      bg-icon="green"
      icon="fas fa-file-plus"
      content="Añadir Documento"
      container-class="tag-badge-main-info mt-4 mb-2"
    />
    <ValidationObserver ref="observer">
      <div class="col-12 px-0 d-flex py-4 align-items-start">
        <div class="col-3 pt-0">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <CustomInput
              v-model="info.name"
              label="Nombre:"
              :error="errors[0]"
              :custom-error-msg="errorMsgs.nombre"
            />
          </ValidationProvider>
        </div>
        <div class="col-2 pt-0">
          <ValidationProvider
            v-slot="{ errors }"
            name="Documento"
            rules="required"
          >
            <CustomDropDown
              v-model="info.category"
              label="Categoría:"
              placeholder="Seleccionar"
              fieldkey="id"
              fieldname="name"
              :error="errors[0]"
              :custom-error-msg="errorMsgs.categoria"
              :options="categoryList"
            />
          </ValidationProvider>
        </div>
        <div class="col-5 pt-0">
          <ValidationProvider
            v-slot="{ errors }"
            name="Archivo"
            rules="required"
          >
            <CustomFileInput
              ref="attachedDocument"
              v-model="info.document"
              label="Documento:"
              :accept="accept"
              :not-cloud-download="true"
              required
              display-style="normal"
              label-position="left"
              :error="errors[0]"
              custom-error-msg="Favor anejar documento."
            />
          </ValidationProvider>
        </div>
        <div class="col p-0 buttons-container justify-content-end d-flex">
          <ActionButton
            variant="outline-danger mr-2"
            i="fas fa-times-circle"
            @click="cancelFile"
          >
            Cancelar
          </ActionButton>
          <ActionButton variant="success" i="fas fa-file-plus" type="submit">
            Añadir
          </ActionButton>
        </div>
      </div>
    </ValidationObserver>
  </form>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import { CustomInput, CustomDropDown, ActionButton } from '@/components/common';
import CustomFileInput from '@/components/common/CustomFileInput';
import general from '@/services/pei/general';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import loading from '@/mixin/loading.mixin';
import fileInputStatus from '@/utils/constants/fileInputStatus';

export default {
  name: 'ServiceDocumentAdd',
  mixins: [loading],
  data() {
    return {
      errorMsgs: {
        nombre: 'Favor de entrar el nombre.',
        categoria: 'Favor de selecional una categoría.',
        document: 'Favor de anejar el documento.',
        errorOnSaving: 'Se ha producido un error al guardar el documento',
        missingFields: 'Se requiere completar todos los campos para continuar',
      },
      info: {
        name: '',
        category: null,
        document: null,
      },
      categoryList: [
        {
          id: 75,
          name: 'Evaluación',
        },
        {
          id: 76,
          name: 'Minuta',
        },
      ],
    };
  },
  props: {
    studentServiceId: {
      type: Number,
      default: null,
    },
    immediateSave: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
      default: '*',
    },
  },
  methods: {
    checkValidation() {
      let self = this;
      let isValid =
        self.info.name !== '' &&
        self.info.category !== null &&
        self.info.document !== null;
      return isValid;
    },
    async handleSubmit(e) {
      e.preventDefault();
      const isValid = await this.$refs.observer.validate();
      if (!this.checkValidation() || !isValid) return;

      if (this.immediateSave) {
        const peiId = this.$store.getters.SelectedPei.toString();
        const formData = new FormData();
        formData.append('attachment', this.info.document);
        formData.append('fileName', this.info.document.name);
        formData.append('StudentServiceId', this.studentServiceId ?? 0);
        formData.append('documentTitle', this.info.name);
        formData.append('peiAttachmentTypeCode', this.info.category.id);
        formData.append('peiId', peiId);

        await this.$ApiPost(
          'api/pei/savethrpyreferralitemattachment',
          formData
        );
      }
      this.$emit('on-add', { ...this.info });
    },
    cancelFile() {
      this.$emit('on-cancel', { ...this.info });
    },
    downloadFile() {
      let self = this;
      let file = self.info.document;
      general.downloadDocumentForThrerapyReferral(file);
    },
    cancelSelectedFile() {
      this.info.document = null;
      this.info.name = '';
      this.info.category = null;
    },
  },
  components: {
    ActionButton,
    CustomInput,
    CustomFileInput,
    CustomDropDown,
    ValidationObserver,
    ValidationProvider,
    SectionTitle,
  },
  computed: {
    regStudentId() {
      return this.$store.getters['$_student/getRegStudentId'];
    },
    file() {
      return this.info.document;
    },
  },
  watch: {
    file(value) {
      if (!value) return;

      let reader = new FileReader();
      reader.readAsDataURL(value);

      let localDocument = this.$refs.attachedDocument;
      localDocument.file = value;
      localDocument.status = fileInputStatus.Loaded;
      localDocument.fileReader = reader;
      localDocument.fileLabel = value.name;
    },
  },
};
</script>

<style scoped>
.box-icon-button-custom >>> .btn {
  padding: 1px 23px;
  width: 100%;
}

.badge-modal-custom >>> .tag-badge-title {
  font-size: 20px;
}
.danger-text {
  color: #e85c5c;
}
.buttons-container {
  margin-top: 29px;
}
</style>
